module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-snackbar', {
    staticClass: "snackbar",
    attrs: {
      "color": _vm.globalSnackColor,
      "timeout": 4000,
      "right": true,
      "top": true,
      "value": _vm.globalSnackDisplay
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.globalSnackMessage) + "\n\t\t")]), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mainMenu",
    staticStyle: {
      "padding-bottom": "0px !important",
      "overflow-y": "scroll !important",
      "": ":-webkit-scrollbar: width: 5px !important"
    },
    attrs: {
      "mobile-break-point": "10240",
      "clipped": "",
      "fixed": "",
      "hide-overlay": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('div', {
    staticClass: "menu_holder"
  }, [(_vm.objAuthorize.type != 6) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.fncGoPage('/')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticStyle: {
      "color": "yellow"
    }
  }, [_vm._v("insert_chart")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Dashboard")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.fncCheckSettings()) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.fncShowSettings()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("General Settings")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.fncCheckSettings()) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.fncShowInstallations()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("gavel")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Installations")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.email == 'superuser@ndtec.co.za') ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.fncShowSetup()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("build")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("MyOrder Setup")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.email == 'superuser@ndtec.co.za') ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.fncGoPage('/tokens/')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("fingerprint")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Tokens")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.email == 'superuser@ndtec.co.za' || _vm.objAuthorize.email == 'bwsuperuser@ndtec.co.za') ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.fncGoPage('/vendors/')
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("receipt")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Vendor List")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges && _vm.objAuthorize.type != 6 && _vm.objAuthorize.privileges.indexOf('STOCK_AVAILABILITY') !== -1) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        return _vm.fncShowStock()
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("list")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Stock Availability")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.menu), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "menu_holder"
    }, [(_vm.objAuthorize.privileges && _vm.objAuthorize.privileges.indexOf(item.priv) !== -1 || item.priv === 'All') ? _c('v-list-tile', {
      on: {
        "click": function($event) {
          return _vm.showNavChildren(item.id, item.link, index)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      style: ({
        color: item.color
      })
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((item.children), function(subItem, subIndex) {
      return (_vm.clickStatus[index][item.id] && (_vm.objAuthorize.privileges.indexOf(subItem.priv) !== -1 || subItem.priv === 'All')) ? _c('v-list-tile', {
        key: subItem.id,
        staticClass: "navChild",
        attrs: {
          "id": _vm.objAuthorize.privileges.indexOf(subItem.priv_not) != -1
        }
      }, [_c('v-list-tile-content', {
        staticClass: "navChilditem"
      }, [_c('v-list-tile-title', {
        staticClass: "cursor",
        on: {
          "click": function($event) {
            return _vm.fncGoPage(subItem.link)
          }
        }
      }, [_c('span', {
        staticClass: "subIcon",
        style: ({
          background: item.color
        })
      }, [_vm._v(_vm._s(_vm.showFirstLetter(subItem.title)))]), _vm._v(_vm._s(_vm.fncSubMenuTitle(subItem.title)))])], 1)], 1) : _vm._e()
    })], 2)
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "navbar",
    attrs: {
      "dark": "",
      "fixed": "",
      "app": ""
    }
  }, [_c('v-flex', {
    staticClass: "header-links",
    attrs: {
      "xs5": ""
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "color": "white"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleDrawer.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.objAuthorize.privileges && _vm.objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1) ? _c('v-btn', {
    staticClass: "pl-0 widget-link",
    class: {
      'active': _vm.isActiveButtonLite
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncGoQuoteReportsLite()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "display": "block !important"
    }
  }, [_vm._v("bolt")]), _vm._v(" Quotes Bolt\n        ")]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('VIEW_WIDGETS') !== -1) ? _c('v-btn', {
    staticClass: "pl-0 widget-link",
    class: {
      'active': _vm.ShowWidgets
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncGoWidgets()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("timeline")]), _vm._v(" Widgets\n        ")]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.privileges.indexOf('CAN_SUMMARY_REPORTING') !== -1) ? _c('v-btn', {
    staticClass: "pl-0 widget-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncGoSummary()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("summarize")]), _vm._v(" Summary Reports\n        ")]) : _vm._e(), _vm._v(" "), (_vm.objAuthorize.manufacturer == '385889803' && _vm.objAuthorize.privileges && _vm.objAuthorize.privileges.indexOf('VIEW_QUOTES') !== -1) ? _c('v-btn', {
    staticClass: "pl-0 quote-link",
    class: {
      'active': _vm.isActiveButton
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncGoQuoteReports()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("bubble_chart")]), _vm._v(" Quotes (Previous Version )\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "cmsLogo",
    attrs: {
      "xs2": ""
    }
  }, [_vm._v("\n             \n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "myorderlogo": ""
    }
  }, [_c('div', [_c('img', {
    staticStyle: {
      "position": "absolute",
      "margin": "0px auto",
      "text-align": "center",
      "width": "auto",
      "display": "inherit",
      "right": "180px !important"
    },
    attrs: {
      "src": _vm.fncGetLogo(),
      "height": "35"
    }
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/logo.png")
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "userDetails"
  }, [_c('p', {
    staticClass: "loggedUser"
  }, [_vm._v(_vm._s(_vm.userFullname) + " | "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncLogout.apply(null, arguments)
      }
    }
  }, [_vm._v("LOGOUT")])])])])], 1), _vm._v(" "), _c('modal')], 1)
},staticRenderFns: []}